import { render, staticRenderFns } from "./OrderDeliveries.vue?vue&type=template&id=e2bf0c34&"
import script from "./OrderDeliveries.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliveries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports